export interface CreditoFinanceiro {
  id: string;
  descricao: string;
  valor: number;
  campanha: string;
  dataCredito: string; // formato ISO: YYYY-MM-DD
  diasExpiracao: number; // dias a partir da dataCredito para expirar (máx 360)
}

export const creditosFinanceiros: CreditoFinanceiro[] = [
  { id: 'credito-1', descricao: 'Bônus Meta de Vendas', campanha: 'Verão 2024', valor: 2000.0, dataCredito: '2026-01-15', diasExpiracao: 360 },
  { id: 'credito-2', descricao: 'Comissão Vendas Janeiro', campanha: 'Aceleração Q1', valor: 1500.0, dataCredito: '2026-02-28', diasExpiracao: 180 },
  { id: 'credito-3', descricao: 'Prêmio Destaque do Mês', campanha: 'Reconhecimento', valor: 500.0, dataCredito: '2026-03-10', diasExpiracao: 90 },
  { id: 'credito-4', descricao: 'Bônus Indicação Cliente', campanha: 'Indica e Ganha', valor: 300.0, dataCredito: '2026-03-25', diasExpiracao: 60 },
];
